module.exports = __webpack_public_path__ + "img/bb.9d969548.svg";